export interface SalesRepProfile {
  staffName: string;
  role: string;
  email: string;
  phone: string;
}

export interface AssignedTerritory {
  name: string;
}

export interface EmployeeInfo {
  staffId: string;
  startedSince: string;
}

export type RouteStopStatus = 'Completed' | 'Pending';

export interface ProfileRouteStop {
  id: string;
  index: number;
  name: string;
  time: string;
  status: RouteStopStatus;
}

export interface PerformanceStat {
  id: string;
  label: string;
  value: string;
}

export interface SettingsItem {
  id: string;
  icon: 'bell' | 'globe' | 'wifi' | 'gear';
  title: string;
  subtitle: string;
}

export const defaultSettingsItems: SettingsItem[] = [
  { id: 'notifications', icon: 'bell', title: 'Notifications', subtitle: 'Manage notification preferences' },
  { id: 'language', icon: 'globe', title: 'Language', subtitle: 'English (US)' },
  { id: 'offline-mode', icon: 'wifi', title: 'Offline Mode', subtitle: 'Sync when online' },
  { id: 'general', icon: 'gear', title: 'General Settings', subtitle: 'App preferences and defaults' },
];
